<template>
  <div>
      <header>
          <div class="headerOne">
              <i class="el-icon-arrow-left" @click="userNameOne"></i>
              <span class="buss">个人信息</span>
          </div>
      </header>
       <div class="headerTwo">
            <ul>
              <li @click="actionSheet ">
                <span class="personOne oldOne">头像</span>
                  <img :src="img" alt="" class="portrait">
              </li>
              <li >
                <span class="personOne">会员名</span>
                <div class="personTwo">
                  <input type="text" placeholder="请输入"  v-model="cardName" maxlength="8" @blur="nickName">
                </div>
              </li>
              <li >
                <span class="personOne">身份证</span>
                <div class="personTwo" >
                   <input type="text" placeholder="请输入"  v-model="numId" class="numId"  @input="numIdNumber"  :disabled="isDisabled">
                </div>
              </li>
              <li @click="openPicker">

                <span class="personOne ">生日</span>
                <div class="personTwo" >
                   <input type="text" placeholder="请选择" class="personOne"  v-model="birthday" readonly >
                </div>
              </li>
              <li>
                  <span class="personOne">性别</span>
                  <div class="personTwo" @click="gogender" >
          
                      <input type="text" placeholder="请选择" class="personOne"  readonly  v-model="sex">
                  </div>
              </li>
              <li @click="signatureOne">
                <span class="personOne">签名</span>
                <div class="personTwo">
                  <input type="text"  placeholder="请输入" v-model="signature"  class="overFlow">
                 </div>
              </li>
            </ul>
          </div>
             <mt-popup v-model="popupVisible2" popup-transition="popup-fade" class="mint-popup-2" :modal="false">
                   <p v-text="msg"></p>
             </mt-popup>
          <!-- <div class="sub" @click="subOne();popupVisible2" >
                提 交
          </div> -->
             <mt-actionsheet :actions="actions" v-model="sheetVisible"></mt-actionsheet>
            <!-- 出生日期选择 -->
            <mt-datetime-picker
                  ref="picker"
                @confirm="handleConfirm"
                v-model="pickerVisible"
                type="date"
                year-format="{value} 年"
                month-format="{value} 月"
                date-format="{value} 日"
                :startDate=startDate
                :endDate=endDate
                >
            </mt-datetime-picker>

  </div>
</template>
<script>
import { DatetimePicker,Popup,Toast,Indicator,Radio,MessageBox } from "mint-ui";
import {mapState} from 'vuex'
export default {
name:"personage",
      data() {
        return {
          popupVisible2: false,
          baseNew:"",
          mode:"",
          sign:"",
          flag:true,
          msg:"",
          popupVisible2:false,
          // value1:"",
          xianshi:false,

        // 性别选择
          label:"",
          value1:"",
          pickerVisible: "",
          labelOne:"",
         
          cardName:this.$store.state.userinfo.nick,   //昵称
          birthday:this.$store.state.userinfo.birthday,  //生日
          sex:this.$store.state.userinfo.sex,  //性别
          signature:this.$store.state.userinfo.info,
          signature:this.$store.state.userinfo.info,
          numId:"",  //身份证
          option: {
            img:'',
            outputType: "png",
            autoCropWidth: document.body.offsetWidth * 0.8,
            autoCropHeight: document.body.offsetWidth * 0.8
          },
          cropShow:false,
          crop: false, //裁剪显示隐藏
          photoType: "",
          img: "", //初始头像=>裁剪过后的图片
          sheetVisible: false,
          actions: [],
          imageUrl: "",
          //身份证号码
          centerDialogVisible: false,
          boyOne: "男",
          girlsOne: "女",
          pickerVisible: "",
          startDate: new Date("1970-01-01"),
          endDate: new Date(),
           isDisabled:false
        };
      },

    computed:{
     wsWbsocket(){
         return this.$store.state.wsWbsocket;
         }
  },
    created() {
      
           var  numId=this.$store.state.identityCard //身份证
           if(numId){
              this.isDisabled=true
              var newOne=numId
              this.numId= newOne//身份证
           }else{
              console.log("无")
           }
           var  imgSrc=this.$store.state.imgSrc
           if(imgSrc){
            this.img=imgSrc
           }else{
                 this.img=require("../../assets/images/header.png")
           }
            if(this.$store.state.userinfo.sex==0){
                      this.sex="男"
            }else if(this.$store.state.userinfo.sex==1){
              this.sex="女"
            }
      },
      // 选取功能 拍照 还是相册选取
    mounted() {
        this.actions = [
          {
            name: "拍照",
            method: this.myCamera
          },
          {
            name: "从相册中选择",
            method: this.myGallery
          }
        ];
      },
    methods: {
        //  当修改昵称失去焦点的时候触发  提交修改的昵称
         nickName(){
                console.log(this.cardName)
                     var dataOne='"'+'nick'+'":'+'"'+this.cardName+'"';
                ws.send('{"action":"UpdateUserInfoByUid",'+dataOne+'}');
                 ws.onmessage = (res)=>
                  {
                    var obj = JSON.parse(res.data);
                    if(obj.action=="UpdateUserInfoByUid"){
                          console.log(1111,obj)
                          
                    }
                  } 
         },
        // 失去焦点绑定身份证
          numIdNumber(){
            if(this.numId.length==18){
              console.log(this.numId)
              setTimeout( ()=>{
                    MessageBox({
                      title: '提示',
                      message: '身份证一旦绑定将无法修改!',
                      showCancelButton: true
                  }).then(action => {
                       var regThree = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
                        //输入的身份证号码
                            if (regThree.test(this.numId)) {
                                       var identityOne='"'+'identity'+'":'+'"'+this.numId+'"';
                                        ws.send('{"action":"UpdateUserInfoByUid",'+identityOne+'}');
                                          ws.onmessage = (res)=>
                                          {
                                            var obj = JSON.parse(res.data);
                                             console.log(res)
                                              
                                            if(obj.action=="UpdateUserInfoByUid"){
                                                  if(obj.s==0){
                                                      Toast('修改成功');
                                                      this.isDisabled=true
                                                      var newphoneNum =this.numId.replace(/^(\d{3})\d{11}(\d+)/,"$1***********$2");
                                                      console.log(phoneNum)
                                                      this.$store.commit("getIdentity",newphoneNum)  
                                                  }else if(obj.s==1029){
                                                      Toast('身份证错误');
                                                  }
                                            }

                                          }

                            }else{
                             
                              Toast('请输入有效的身份证');
                            }
                            

                        });
              }, 300 )
              
          }
        },
        gogender(){
            this.$router.push({
                  path: "gender"
                });
        },
        
        selectGet(value){
          $("input").focus(function(){
            document.activeElement.blur();
          })
          let obj = {};
          obj = this.options.find((item)=>{
              return item.value === value;
          });
          this.labelOne=obj.label
          this.$store.commit("changeGender",obj.label);
        },
        
    
        userNameOne(){
          this.$router.push({
            path: "/setting"
          });
        },
        //跳转到会员名页面
        userName() {
          this.$router.push({
            path: "/user"
          });
        },

        // 点击进行拍照
        myCamera() {
        //相机
                  navigator.camera.getPicture(this.onSuccess, this.onFail, {
                            quality: 50,
                            sourceType: Camera.PictureSourceType.Camera,    //选择相机
                            destinationType: Camera.DestinationType.DATA_URL  ,    //DATA_URL：返回的是base64位的字符串  FILE_URI：返回的是uil文件
                        })  ;
                },
        onSuccess(imageURI){
          //  alert(imageURI)  //imageURI==>base64
          this.baseNew=imageURI
          this.img="data:image/jpeg;base64," + imageURI;
          var baseNew=this.baseNew
          $.post(setPortrait+"&uid="+uid+"&mode="+mode+"&sign="+sign+"&isCustom="+1,{
              "upFile":baseNew,
          },(res)=>{
            // alert(res)

          }
      )
                                           
        },
        // 点击进行相册上传
        myGallery() {
          navigator.camera.getPicture(this.onSuccess, this.onFail, {
                            quality: 50,
                            destinationType: Camera.DestinationType.DATA_URL,  //DATA_URL：返回的是base64位的字符串  FILE_URI：返回的是uil文件
                            sourceType : Camera.PictureSourceType.SAVEDPHOTOALBUM,   //选择相册
                      })

        },

        actionSheet() {
          this.sheetVisible = true;
        },

        userInf() {
          // if(this.numId){
          //     Toast('身份证已绑定');
          //      this.flag=false;
          //      $(".numId").attr('readonly',true)
          // }else{
          //  this.$router.push({ path: "/identity" });
          // }

        },

        signatureOne() {
          this.$router.push({ path: "/signature" });
        },
        openPicker() {
          this.$refs.picker.open();
        },
        //选择生日
        handleConfirm() {     
          var d = new Date(this.pickerVisible);
          var youWant =d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
            console.log(youWant)
          if (youWant === "NaN-NaN-NaN") {
            console.log(youWant);
              this.birthday="1970-01-01"
                 var birthdayOne='"'+'birthday'+'":'+'"'+ this.birthday+'"';
                  ws.send('{"action":"UpdateUserInfoByUid",'+birthdayOne+'}');
                 ws.onmessage = (res)=>
                  {
                    var obj = JSON.parse(res.data);

                    if(obj.action=="UpdateUserInfoByUid"){
                          console.log(1111,obj)
                        this.$store.state.userinfo.birthday= this.birthday
                    }
                  }
          } else {
               this.birthday=youWant
               var birthdayOne='"'+'birthday'+'":'+'"'+ this.birthday+'"';
                ws.send('{"action":"UpdateUserInfoByUid",'+birthdayOne+'}');
                  ws.onmessage = (res)=>
                      {
                        var obj = JSON.parse(res.data);

                        if(obj.action=="UpdateUserInfoByUid"){
                              console.log(222,obj)
                            this.$store.state.userinfo.birthday= this.birthday
                        }
                      }
          }
        },

      }
};
</script>
<style scoped>
.oldOne{
  vertical-align: middle
}
.el-icon-arrow-left{
    font-size: 0.7rem;
    line-height:1.6rem;
     margin-left: 0.2rem
}
.personOne{
  background: white
}
.headerOne .buss {
  display: inline-block;
  font-size: 0.55rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.crop{
      position: fixed;
      top:-6rem;
      bottom: 0;
      left: 0;
      right: 0;
      background: #000000;
      color: #fff;
      font-size: .5rem;
}
.fot{
        position: absolute;
        height: 1rem;
        width: 100%;
        bottom: 0;
        border-top: 1px solid rgba(0, 0, 0, 0.6);
        background: rgba(0, 0, 0, 0.8)
}
.fot p:nth-child(1){
  margin-top: 0.2rem;
  margin-left: 0.35rem
}
.fot p:nth-child(2){
 margin-top: 0.2rem;
margin-right: 0.35rem
}
header {
  height: 1.6rem;
  width: 100%;
  border-bottom: 1px solid rgba(48, 1, 1, 0.2);
  position: relative;
}
.headerOne {
  font-size: 0;
}
.headerOne img {
  display: inline-block;
  margin-top: 0.3rem;
}
.portrait{
  border-radius:0.5rem;
  height:2rem;
  width: 2rem;
  vertical-align: middle;
  margin-left: 5.5rem;
  margin-bottom: 0.2rem
}
.headerOne img:nth-child(1) {
  margin-left: 0.2rem;
}

.headerTwo ul li {
  width: 90%;
  margin: 0 auto;
  margin-top: 0.3rem;
  position: relative;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
.headerTwo ul li input{
  height: 1.6rem;
    text-align: right;
  color:  rgba(0, 0, 0, 0.9);
  border: none;
  outline: none;
  width:7rem;

}
.headerTwo ul li div {
  display: inline-block;
}
.headerTwo ul li span {
  color: rgba(0, 0, 0, 0.9);
  font-size: 0.55rem;
}

.headerTwo ul li .personTwo {
  width: 7rem;

  height: 1.6rem;

display: inline-block !important
}
input{
  font-size: 0.55rem;
  text-align: right !important;
  text-indent: 2rem
}
input::-webkit-input-placeholder {

font-size: 0.55rem;
 color: rgba(0, 0, 0, 0.5)
}
.headerTwo ul li .personTwo img {
  width:2rem;


}
.headerTwo ul li .personTwo .membership {
  display: inline-block;
  width:95%;
  text-align: right;
  color: rgba(0, 0, 0, 0.5);
}

.personTwo .numId{
  color: red;
      text-indent: 1rem !important;
          background: white;
}
.headerTwo ul li .personTwo .goOn {
  width: 0.18rem;
  height: auto;
  margin-top: 0.86rem;
}
.overFlow{
 overflow: hidden;
 white-space: nowrap;
 text-overflow: ellipsis
}
.sub {
  color: white;
  font-size: 0.55rem;
  width: 90%;
  background-image: linear-gradient(to right, #2ea4b0, #06789d);
  margin:1.5rem auto;

  height: 1.2rem;
  border-radius: 15px;
  text-align: center;
  line-height: 1.2rem;
}
.v-modal {
  display: none !important;
}
/* #birthdayOne{margin-left:0rem } */
</style>



// WEBPACK FOOTER //
// src/components/personage/personage.vue